import appComponents from './hi-IN/appComponents';
import appPages from './hi-IN/appPages';
import common from './hi-IN/common';
import component from './hi-IN/component';
import globalHeader from './hi-IN/globalHeader';
import menu from './hi-IN/menu';
import pages from './hi-IN/pages';
import pwa from './hi-IN/pwa';
import settingDrawer from './hi-IN/settingDrawer';
import settings from './hi-IN/settings';

export default {
  'navBar.lang': 'भाषाएँ',
  'layout.user.link.help': 'सहायता',
  'layout.user.link.privacy': 'गोपनीयता',
  'layout.user.link.terms': 'शर्तें',
  'app.copyright.produced': 'Produced by Ant Financial Experience Department',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  'login.forgotPassword.support': 'पासवर्ड भूल गए',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...common,
  ...appPages,
  ...appComponents,
};
